import { langTypes } from '../settings/types'
import { changeLoadingState } from "./genericActions";
import { langService } from "../../jwt/_services";
import {setLoading} from "./generalActions/mainActions";

export const searchActiveLangs = () => (dispatch) => {
    dispatch(changeLoadingState(true))
    dispatch(setLoading(true))

    langService.getAll()
        .then(result => {
            if (!result)
                return

            dispatch( setLangs(result) );
            dispatch(   setLoading(false) );
        })
        .finally(() => {
            dispatch( changeLoadingState(false) );
            dispatch( setLoading(false) );
        })
}


export const setLangs = data => ({
    type: langTypes.register,
    payload: data
})

export const clearLangs = () => ({
    type: langTypes.clearLangs,
})